<template>
  <span
    v-if="value"
    :class="`two-colored-status-${value}`">{{ value }}</span>
  <span v-else>n/a</span>
</template>

<script>
export default {
  name: 'two-colored-status',
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
  },
}
</script>

<style lang="scss">
  @import '~@scss/variables';

  .two-colored-status-GREEN {
    color: $col-sumsub-review-answer-green;
    font-weight: 600;
  }

  .two-colored-status-RED {
    color: $col-sumsub-review-answer-red;
    font-weight: 600;
  }

</style>
